// extracted by mini-css-extract-plugin
module.exports = {"tabs__container":"ReportingTabs_tabs__container__1dvCd","tabs__tab":"ReportingTabs_tabs__tab__1QouJ"};